<template>
  <!--
    The blocker, stated once at the top: what is missing, and how much. The
    chips are buttons because the whole point is to get to the field — reading
    that two things are missing without a way to reach them is a dead end.
  -->
  <div class="flex flex-col gap-3 px-6 py-3 bg-warning-subtle border-b border-border sm:flex-row sm:items-center">
    <div class="flex items-center gap-3 flex-1">
      <CircleAlert class="size-4 shrink-0 text-warning-subtle-foreground" />
      <p class="flex-1 text-sm font-bold text-warning-subtle-foreground">
        {{ fields.length }} {{ fields.length === 1 ? 'thing needs' : 'things need' }}
        you before this can be created
      </p>
    </div>
    <ul class="flex flex-wrap gap-2">
      <li
        v-for="field in fields"
        :key="field.key"
      >
        <button
          type="button"
          class="px-2.5 py-1 text-xs font-bold cursor-pointer bg-card rounded-full border
            transition-[background-color,border-color] duration-ds-fast ease-ds-standard
            focus-visible:outline-none focus-visible:shadow-ds-focus"
          :class="field.key === activeKey
            ? 'border-warning text-warning-subtle-foreground'
            : 'border-input text-foreground hover:border-strong'"
          @click="emit('focus-field', field.key)"
        >
          {{ field.label }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { CircleAlert } from '@lucide/vue'

import { WizardMissingField } from '../utils/types'

defineProps<{
  fields: WizardMissingField[]
  /** The one currently being answered, highlighted amber. */
  activeKey?: string
}>()

const emit = defineEmits<{
  (e: 'focus-field', key: string): void
}>()
</script>
